export const getVenueName = state => state.venue?.currentVenue?.displayName ?? 'Arena'
